import { Divider, Stack } from "@mui/material"
import { If } from "lib/@components/switch"
import { Frag } from "lib/@components/slot/frag"
import { InlineCompareButtons } from "routes/schedule/compare/inline-approval-buttons/inline-compare-buttons"
import { getAttributesFor } from "routes/schedule/compare/register-task-comparitor"
import { DifferenceEntry } from "slot-definitions"
import { AuthoringReviewAmendsBlock } from "./authoring-review-amends-block"
import { AuthoringReviewPriorRejection } from "./authoring-review-prior-rejection"

export function AuthoringReviewComparisonTypeEntry({
    component,
    index,
    last,
    rendered,
    to,
    from,
    amendsKey,
    subtitle,
    showInlineButtons = false,
    idFromGroup,
}) {
    const { type: Type, props } = component
    const renderedEntry = rendered?.[index]
    const entryName = getEntryName(component, renderedEntry)
    const resolvedAmendsKey = amendsKey ?? getEntryAmendsKey(component, renderedEntry)
    const resolvedSubtitle = subtitle ?? getEntrySubtitle(component, renderedEntry)
    const resolvedIdFromGroup = idFromGroup ?? getEntryIdFromGroup(entryName, props, index)

    return (
        <Frag>
            <DifferenceEntry.Slot>
                <Type {...props} />
            </DifferenceEntry.Slot>
            <AuthoringReviewPriorRejection amendsKey={resolvedAmendsKey} />
            <AuthoringReviewAmendsBlock amendsKey={resolvedAmendsKey} subtitle={resolvedSubtitle} />
            <If value={showInlineButtons}>
                <Stack spacing={2} mt={2}>
                    <InlineCompareButtons
                        idFromGroup={resolvedIdFromGroup}
                        to={to}
                        from={from}
                        rendered={[rendered[index]]}
                    />
                </Stack>
            </If>
            <If value={!last}>
                <Divider sx={{ mx: -3 }} />
            </If>
        </Frag>
    )
}

function getEntryAmendsKey(component, renderedEntry) {
    const entryName = getEntryName(component, renderedEntry)

    switch (entryName) {
        case "title":
            return "title"
        case "code":
        case "unitOfMeasure":
        case "intro.content":
        case "intro.note":
            return entryName
        default:
            return null
    }
}

function getEntrySubtitle(component, renderedEntry) {
    const entryName = getEntryName(component, renderedEntry)

    switch (entryName) {
        case "title":
            return "Change Schedule Title Reason"
        case "code":
            return "Change Schedule Code Reason"
        case "unitOfMeasure":
            return "Change Unit of Measure Reason"
        case "intro.content":
            return "Change Introduction Reason"
        case "intro.note":
            return "Change Note Reason"
        default:
            return undefined
    }
}

function getEntryIdFromGroup(entryName, props, index) {
    if (entryName === "title") return "details"
    if (entryName === "code") return "details:code"
    if (entryName === "unitOfMeasure") return "details:unitOfMeasure"
    if (entryName === "intro.content" || entryName === "intro.note") return entryName
    return `details:${props?.path ?? props?.label ?? index}`
}

function getEntryName(component, renderedEntry) {
    return (
        getAttributesFor(component)?.name ??
        getAttributesFor(component?.props?.children)?.name ??
        getAttributesFor(renderedEntry)?.name ??
        getAttributesFor(renderedEntry?.props?.children)?.name ??
        null
    )
}
